import PropTypes from "prop-types";
import React from "react";

import ModalLink from "v2/components/responsive/ModalLink";
import CancelDestinationForm from "v2/components/responsive/CancelDestinationForm";

const CancelDestinationLink = (props, context) => {
  const {params: {date, id, routeId}} = context;
  return (
    <ModalLink
      form={CancelDestinationForm}
      label="Cancel Destination"
      url={`/${date}/${routeId}/${id}/cancel`}
      {...props} />
  );
};

CancelDestinationLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default CancelDestinationLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/CancelDestinationLink.js
 **/